// extracted by mini-css-extract-plugin
export default {"grid":"ProductGrid_grid__MLAen","empty":"ProductGrid_empty__ED+ZW","emptyText":"ProductGrid_emptyText__jKTz0","emptyHint":"ProductGrid_emptyHint__Y9Kkn"};